import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiResultModel, getPIMExportApi } from "@tecumseh/Services/PIMExportHistoryService";
import { ApiResultTemplateListModel, getPIMTemplateList } from "@tecumseh/Services/PIMGetTemplateListService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface Parameter {
    query?: any;
    onError?: (errorMessage: string) => void;
}

type HandlerType = CustomApiHandler<Parameter, ApiResultTemplateListModel>;

export const StartLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/PIMGetTemplateList/startLoading",
    });
};

export const GetTemplateList: HandlerType = async props => {
        try {
            const result = await getPIMTemplateList({});
            props.dispatch({
                type: "Custom/PIMGetTemplateList/SetContents",
                contentResults: result,
            });
        } catch (error) {
            throw error;
        }
    
};


export const chain = [StartLoading, GetTemplateList];

const getCustomerTemplateList = createHandlerChainRunner(chain, "getPIMExport");
export default getCustomerTemplateList;
